import { app, device_delete } from "./firebase";
import {
    getFirestore,
    doc,
    collection,
    setDoc,
    getDoc,
    addDoc,
    serverTimestamp,
    deleteDoc,
    query,
    where,
    getDocs,
    writeBatch
} from "firebase/firestore";

export const db = getFirestore(app);

export async function createUserDoc (uid) {
    // TODO: Check if user already exists, before setting it
    if ( doc(db, "users", uid))
    return setDoc(doc(db, "users", uid), {
        created: serverTimestamp()
    })
}

// export async function createBuisness (uid) {
//     if (!uid) {
//         throw new Error("uid is undefined. Can not create a business owned by undefined");
//     }

// }

export async function createBusiness (owner) {
    const newDoc = await addDoc(collection(db, "businesses"), {
        created: serverTimestamp(),
        updated: serverTimestamp(),
        visible: false,
        wasVisibleBefore: false,
        owner,
        followerCount: {
            notificationEnabled: 0,
            total: 0
        },
        images: {
            avatar: "https://firebasestorage.googleapis.com/v0/b/schnappodil-2f0a7.appspot.com/o/images%2F_presets%2Favatars%2Fplaceholder.png?alt=media&token=26e4fb9a-2ad7-4ae9-86f0-6436877b30d9",
            stamp: "https://firebasestorage.googleapis.com/v0/b/schnappodil-2f0a7.appspot.com/o/images%2F_presets%2Fstamps%2Flokodil.png?alt=media&token=b4d5a5c2-f155-460a-8874-17026cabd7dd",
            title: "https://firebasestorage.googleapis.com/v0/b/schnappodil-2f0a7.appspot.com/o/images%2F_presets%2Ftitles%2Fplaceholder.png?alt=media&token=1f79f348-58b9-4e89-8c84-73196ac1ca3f"
        },
        location: {
            geohash: ""
        },
        credits: {
            months: {
                0: {reserved: 0, spent: 0, reserved_extra: 0},
                1: {reserved: 0, spent: 0, reserved_extra: 0},
                2: {reserved: 0, spent: 0, reserved_extra: 0},
                3: {reserved: 0, spent: 0, reserved_extra: 0},
                4: {reserved: 0, spent: 0, reserved_extra: 0},
                5: {reserved: 0, spent: 0, reserved_extra: 0},
                6: {reserved: 0, spent: 0, reserved_extra: 0},
                7: {reserved: 0, spent: 0, reserved_extra: 0},
                8: {reserved: 0, spent: 0, reserved_extra: 0},
                9: {reserved: 0, spent: 0, reserved_extra: 0},
                10: {reserved: 0, spent: 0, reserved_extra: 0},
                11: {reserved: 0, spent: 0, reserved_extra: 0},
            },
            extra: {available: 5, spent: 0}
        },
        lotterySettings: [],
        openingHours: {
            regular: [],
            specialDays: {}
        },
        cardSettings: []
    });
    return(newDoc.id);
}

export async function _deleteBusinessesOfOwner (owner) {
    const q = query(collection(db, "businesses"), where("owner", "==", owner));
    const batch = writeBatch(db);
    const ownedBuisnesses = await getDocs(q);
    ownedBuisnesses.forEach((doc) => {
        batch.delete(doc.ref);
    });
    return batch.commit();
}

export async function _deleteCardSettingsOfOwner (owner) {
    const q = query(collection(db, "cardSettings"), where("owner", "==", owner));
    const batch = writeBatch(db);
    const ownedCardSettings = await getDocs(q);
    ownedCardSettings.forEach((doc) => {
        batch.delete(doc.ref);
    });
    return batch.commit();
}

// export async function _deleteImagesOfOwner (owner) {
//     const q = query(collection(db, "images"), where("owner", "==", owner));
//     const batch = writeBatch(db);
//     const ownedCardSettings = await getDocs(q);
//     const promises = [];
//     ownedCardSettings.forEach((doc) => {
//         const uid = (doc.data()).uid;
//         promises.push(device_delete({uid}))
//         batch.delete(doc.ref);
//     });
//     await Promise.all(promises);
//     return batch.commit();
// }

export async function _deleteDevicesOfOwner (owner) {
    const q = query(collection(db, "devices"), where("owner", "==", owner));
    const batch = writeBatch(db);
    const ownedCardSettings = await getDocs(q);
    const promises = [];
    ownedCardSettings.forEach((doc) => {
        const uid = (doc.data()).uid;
        promises.push(device_delete({uid}))
        batch.delete(doc.ref);
    });
    await Promise.all(promises);
    return batch.commit();
}

export async function _deleteBusiness (id) {
    return deleteDoc(doc(db, "businesses", id));
}